module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/site_logo_small-17e8adc2434d7e5d188b7b85e5e6ee5c.png";